import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: end;
  gap: 5px;

  margin-top: 24px;
`
